export const groq = String.raw || ((strings, ...keys) => {
  const lastIndex = strings.length - 1;
  return strings.slice(0, lastIndex).reduce(
    (query, currentString, index) => query + currentString + keys[index],
    ""
  ) + strings[lastIndex];
});
